exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-b870e07e] .star-wrapper {\n  margin-bottom: 5px;\n  font-size: 2.6rem;\n}\n@media (max-width: 767px) {\n[data-v-b870e07e] .star-wrapper {\n    margin-bottom: 15px;\n    font-size: 3.1rem;\n}\n}\n[data-v-b870e07e] .star-wrapper .number {\n  font-size: 1rem;\n}\n", ""]);

// exports
